import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@store/authStore.ts';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const location = useLocation();
    const { isAuthenticated, checkTokenExpiry } = useAuthStore();

    useEffect(() => {
        // 페이지 접근 시마다 토큰 유효성 검사
        if (isAuthenticated) {
            checkTokenExpiry();
        }
    }, [location.pathname, isAuthenticated, checkTokenExpiry]);

    // 인증되지 않았거나 토큰이 만료된 경우
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
